import { render, staticRenderFns } from "./EmpSettingTemplate.vue?vue&type=template&id=98d339c4&"
import script from "./EmpSettingTemplate.vue?vue&type=script&lang=js&"
export * from "./EmpSettingTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports